import { useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatDateRangeLabel } from '../../../../utils/helpers/date'
import { useWidget } from '../WidgetWrapper'
import Text from '../../../../packages/kiti/components/presentation/Text'

const PeriodDescription = props => {
  const { t } = useTranslation('common')
  const { data } = useWidget() || {}
  const date = useFilterValue('date')

  let label = t('widgets.considering') + formatDateRangeLabel(date)
  if (data?.ignoreDate === true) label = t('widgets.allTime')

  return (
    <Text size="xxsmall" color="light5" bold {...props}>
      {label}
    </Text>
  )
}

export default PeriodDescription
